import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    margin-bottom: 10px;
    
    & > tbody > tr > th,
    & > tbody > tr > td {
        padding: 0px 0px 0px 5px;
        vertical-align: middle;
    }

    & > tbody > tr > td:nth-child(2),
    & > tbody > tr > td:nth-child(5) {
        text-align: right;
        padding-right: 5px;
    }
`;

export const ChainStarterListLoopsTableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #dfe7f1;
        text-align: center;
        padding: 1px;
    }

    & > tbody > tr > td {
        text-align: center;
        padding: 1px;
    }
`;

export const ChainTableWrapper = styled(Table)`
    margin-bottom: 5px;
    
    & > thead > tr > th {
        text-align: center;
        padding: 2px 1px 0px 1px;
        background-color: #dfe7f1;
        cursor: default;
        width: 65px;
    }

    & > tbody > tr > td {
        text-align: center;
        padding: 1px;
    }

     & > tbody > tr:hover {
        background-color: #eaf2fa;
    }
`;

export const SsdTableWrapper = styled(Table)`
    margin-bottom: 10px;

    & > thead > tr > th {
        text-align: center;
    }

    & > tbody > tr > td {
        text-align: center;
    }
`;

export const DiagnosticsWrapper = styled.div`
    height: 200px;
    overflow-y: scroll;
    padding: 4px;

    .diag-title {
        font-weight: 600;
    }

    .diag-section {
        margin-bottom: 10px;
    }

    .label {
        background-color: #ccc;
        color: dimgray;
    }
`;